import { createSlice } from '@reduxjs/toolkit';
import { getSubscription, getPaymentHistory } from '../actions/payment';

const paymentSlice = createSlice({
    name: 'payment',
    initialState: {
        loading: true,
        subscriptions: { waste: null, ppwr: null },
        history: [],
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getSubscription.pending, (state) => { state.loading = true; })
            .addCase(getSubscription.fulfilled, (state, action) => {
                state.loading = false;
                state.subscriptions[action.payload.module] = action.payload.data;
            })
            .addCase(getSubscription.rejected, (state) => { state.loading = false; })

            .addCase(getPaymentHistory.fulfilled, (state, action) => {
                state.history = action.payload;
            });
    },
});

export default paymentSlice.reducer;
